/* eslint-disable no-unused-vars */
import {
  extractOnlyNumbers,
  removeMultipleSpace,
  removeSpecialCharAndNumFn1,
  safeToString,
  sliceText
} from "../../../utils/common";
import { calculateDateRanges } from "../../../utils/date-of-birth";
import { safeString } from "../../../utils/logger";

const { minDate, maxDOB } = calculateDateRanges();
const today = new Date().toISOString().split("T")[0];

export const FAMILY_INITIAL_STATE = {
  name: "",
  relationship: "",
  date_of_birth: "",
  is_depend_on_family: false,
  contact_no: "",
  address: ""
};


export const FAMILY_FORM_FIELDS = {
  name: {
    name: "name",
    inputType: "inputField",
    component: "InputField",
    label: "Name",
    fullWidth: true,
    required: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeToString(removeSpecialCharAndNumFn1(value))), 150);
        return value;
      },
    },
  },
  relationship: {
    name: "relationship",
    label: "Relationship",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    required: true,
    placeholder: "Select Here...",
    options: [
      { id: "Spouse", name: "Spouse" },
      { id: "Child", name: "Child" },
      { id: "Parent", name: "Parent" },
      { id: "Sibling", name: "Sibling" },
      { id: "Grandparent", name: "Grandparent" },
      { id: "Grandchild", name: "Grandchild" },
      { id: "Guardian", name: "Guardian" },
      { id: "Relative", name: "Relative" },
      { id: "Friend", name: "Friend" },
    ],
  },
  date_of_birth:  {
    name: "date_of_birth",
    label: "Date Of Birth",
    type: "date",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
    max:today,
    // min:minDate
  },
  is_depend_on_family: {
    name: "is_depend_on_family",
    inputType: "selectField",
    component: "SelectField",
    label: "Dependent on Family",
    fullWidth: true,
    required: true,
    placeholder: "Select Here...",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
  },
  contact_no: {
    name: "contact_no",
    inputType: "inputField",
    component: "InputField",
    label: "Contact No",
    fullWidth: true,
    required: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(extractOnlyNumbers(value), 10);
      }
    }
  },
  address: {
    name: "address",
    inputType: "inputField",
    component: "InputField",
    label: "Address",
    fullWidth: true,
    required: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }
    }
  },
 
};

export const FAMILY_API = {
  FAMILY_CREATE: { url: "/employee/family", method: "POST" },
  FAMILY_UPDATE: { url: "/employee/family", method: "PUT" },
  FAMILY_DELETE: { url: "/employee/family", method: "DELETE" },
  FAMILY_LIST: { url: "/employee/family", method: "GET" },
  MASTER_FAMILY_LIST: {
    url: "/organization/org-bank/admin/master",
    method: "GET",
  },
};

export const FAMILY_TABLE_HEADER = [
  { key: "slNo", label: "SL No.", isShortable: true, isVisible: true },
  { key: "name", label: "Owner Name", isShortable: true, isVisible: true, isColumnSticky: true, isClickable: true, defaultValue: "N/A" },
  { key: "relationship", label: "Relationship", align: "left", isShortable: false, isVisible: true, defaultValue: "N/A" },
  { key: "date_of_birth", label: "Date of Birth", align: "left", isShortable: false, isVisible: true, defaultValue: "N/A" },
  { key: "is_depend_on_family", label: "Dependent on Family", align: "left", isShortable: false, isVisible: true, defaultValue: "No" },
  { key: "contact_no", label: "Contact No", align: "left", isShortable: false, isVisible: true, defaultValue: "N/A" },
  { key: "address", label: "Address", align: "left", isShortable: false, isVisible: true, defaultValue: "N/A" },
  { key: "attachment", label: "Attachment", align: "left", isShortable: false, isVisible: true, defaultValue: "N/A" },
];
